"use client";
import { useI18n } from "@/i18n/provider";
import { withLocaleHref } from "@/i18n/navigation";
import { clientMessages } from "@/i18n/client-messages";
import Link from "next/link";
import { useEffect, useState } from "react";
import { apiRequest, type User } from "@/lib/api";

export function AuthNav() {
  const { locale } = useI18n();
  const t = clientMessages[locale];
  const [user, setUser] = useState<User | null>(null);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let active = true;
    const refresh = () => { apiRequest<{ user: User }>("/auth/me").then((data) => { if (active) setUser(data.user); }).catch(() => { if (active) setUser(null); }).finally(() => { if (active) setReady(true); }); };
    refresh();
    window.addEventListener("promptopia:auth", refresh);
    return () => { active = false; window.removeEventListener("promptopia:auth", refresh); };
  }, []);
  return <Link className="nav-console" href={withLocaleHref(user ? "/console" : "/login", locale)} aria-label={user ? t.myConsole : t.login}>{ready && user ? <><span className="avatar-small">{user.display_name.slice(0, 1).toUpperCase()}</span>{t.myConsole}</> : t.login}<span aria-hidden="true">↗</span></Link>;
}
